import React from 'react'

import InfoParagraph from '../../../../components/landing/InfoParagraph'
import MasonryImages from '../../../../components/landing/MasonryImages'
import {
  ResponsiveTwoColumnLayout,
  SpacedColumn,
} from '../../../../components/landing/display'

import { confidenceImageUrls, hostWithConfidenceInfo } from './content'

const Confidence = () => (
  <ResponsiveTwoColumnLayout>
    <SpacedColumn>
      {hostWithConfidenceInfo.map(({ heading, text }) => (
        <InfoParagraph heading={heading} text={text} key={text} />
      ))}
    </SpacedColumn>
    <div>
      <MasonryImages
        images={confidenceImageUrls}
        imagesPerColumn={{
          1: 3,
          2: 4,
          3: 4,
        }}
      />
    </div>
  </ResponsiveTwoColumnLayout>
)

export default Confidence
